import React from "react";
import { Link } from "react-router-dom";

const PUB = process.env.PUBLIC_URL || "";

export default function Footer({ params }) {
  const p = params || {};
  return (
    <footer className="footer-v2">
      <div className="footer-v2-inner">
        {/* Colonne 1 : Mairie */}
        <div className="footer-v2-col">
          <div className="footer-v2-brand">
            <img src={`${PUB}/logo-lcsf.png`} alt="Blason" />
            <div>
              <strong>{p.mairie_nom || "Mairie de La Chapelle-Saint-Fray"}</strong>
              <div className="muted">Sarthe · Pays de la Loire</div>
            </div>
          </div>
          <p className="footer-v2-addr">
            {p.mairie_adresse || "1 route du Mans"}<br />
            {(p.mairie_cp || "72240") + " " + (p.mairie_ville || "La Chapelle-Saint-Fray")}
          </p>
          {p.mairie_telephone && (
            <p className="footer-v2-contact">
              <span>📞</span> {p.mairie_telephone}
            </p>
          )}
          {p.mairie_email && (
            <p className="footer-v2-contact">
              <span>✉</span> <a href={`mailto:${p.mairie_email}`}>{p.mairie_email}</a>
            </p>
          )}
        </div>

        {/* Colonne 2 : Navigation */}
        <div className="footer-v2-col">
          <h4>Navigation</h4>
          <ul>
            <li><Link to="/actualites">Actualités</Link></li>
            <li><Link to="/calendrier">Calendrier</Link></li>
            <li><Link to="/commune">La commune</Link></li>
            <li><Link to="/demarches">Démarches</Link></li>
            <li><Link to="/vie-locale">Vie locale</Link></li>
            <li><Link to="/contact">Nous contacter</Link></li>
          </ul>
        </div>

        {/* Colonne 3 : Services */}
        <div className="footer-v2-col">
          <h4>Services</h4>
          <ul>
            <li><Link to="/signalements">Signaler un problème</Link></li>
            <li><Link to="/cartographie">Cartographie</Link></li>
            <li><Link to="/rubrique/urgences">Numéros d'urgence</Link></li>
            <li><Link to="/mentions-legales">Mentions légales</Link></li>
            <li><Link to="/admin">Espace administration</Link></li>
          </ul>
        </div>

        {/* Colonne 4 : Réseaux + identité */}
        <div className="footer-v2-col">
          <h4>Suivre la mairie</h4>
          {p.mairie_facebook ? (
            <a href={p.mairie_facebook} target="_blank" rel="noopener noreferrer"
               className="footer-v2-social">
              <span>📘</span> Facebook
            </a>
          ) : (
            <p className="muted">Page Facebook à venir.</p>
          )}
          <div className="footer-v2-compostelle">
            <span className="footer-v2-shell">⌬</span>
            <span>Sur le chemin de Compostelle</span>
          </div>
        </div>
      </div>

      <div className="footer-v2-bottom">
        <span>© {new Date().getFullYear()} {p.mairie_nom || "Mairie de La Chapelle-Saint-Fray"}</span>
        <span className="muted">Site officiel de la commune</span>
      </div>
    </footer>
  );
}
